/** آدرس لوگوی شرکت از client_details */
export function resolveClientLogoUrl(client, details) {
  const d = details || client?.client_details || client?.clientDetails || {};
  if (d.image_url) return d.image_url;
  if (d.company_logo_url) return d.company_logo_url;
  if (client?.company_logo_url) return client.company_logo_url;
  return null;
}

/** آدرس تصویر پروفایل مشتری */
export function resolveClientAvatarUrl(client) {
  return client?.image_url || null;
}
